import { render, staticRenderFns } from "./selectStudents.vue?vue&type=template&id=a947e2fc&scoped=true&"
import script from "./selectStudents.vue?vue&type=script&lang=js&"
export * from "./selectStudents.vue?vue&type=script&lang=js&"
import style0 from "./selectStudents.vue?vue&type=style&index=0&id=a947e2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a947e2fc",
  null
  
)

export default component.exports